import { render, staticRenderFns } from "./AppCoreHeaderRight.vue?vue&type=template&id=647f945b&scoped=true"
import script from "./AppCoreHeaderRight.vue?vue&type=script&lang=js"
export * from "./AppCoreHeaderRight.vue?vue&type=script&lang=js"
import style0 from "./AppCoreHeaderRight.vue?vue&type=style&index=0&id=647f945b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f945b",
  null
  
)

export default component.exports